<template>
	<div class="popover-block">
		<i :id="`popover-id-${id}`" class="fa fa-question-circle font-blue clickable" @click="openPopover()"></i>
		<div class="popover-styles" :class="{'shift-left': rightSide}" v-if="open">{{ content }}</div>
	</div>
</template>
<script>
import $ from 'jquery'

/**
 * Info Popover module is used to display an info icon with a popover to display tooltip information.
 * @class InfoPopover
 * @prop {string} content - The content to display in the tooltip
 * @since 0.0.7
 */

export default {
	data () {
		return {
			open: false,
			id: 0,
			rightSide: false
		}
	},
	props: {
		content: {
			default: ''
		}
	},
	/**
	 * Run on `created` to initialize the click event and generate the element id
	 * @function
	 * @returns {undefined}
	 * @memberof InfoPopover
	 * @version 0.0.7
	 */
	created () {
		this.id = this.generateId()

		let _this = this
		$(window).click(e => {
			let infoPopoverElement = $(_this.$el).find('.fa-question-circle')
			if (!$(e.target).hasClass('fa-question-circle') || ($(e.target).hasClass('fa-question-circle') && e.target.id !== infoPopoverElement.attr('id'))) {
				_this.open = false
			}
		})
	},
	methods: {
		/**
		 * To generate a unique id for the element to prevent conflicts on click events
		 * @function
		 * @returns {string} - A string representing the generated id.
		 * @memberof InfoPopover
		 * @version 0.0.7
		 */
		generateId () {
			let text = ''
			const possibleChar = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

			for (let i = 0; i < 5; i++) {
				text += possibleChar.charAt(Math.floor(Math.random() * possibleChar.length))
			}

			if ($(document).find('#popover-id-' + text).length) {
				this.generateId()
			} else {
				return text
			}
		},
		/**
		 * To open the popover
		 * @function
		 * @returns {undefined}
		 * @memberof InfoPopover
		 * @version 0.0.7
		 */
		openPopover () {
			this.open = true

			if ($(window).width() - $(this.$el).offset().left < 100) {
				this.rightSide = true
			} else {
				this.rightSide = false
			}
		}
	}
}
</script>
<style>
.popover-block {
	position: relative;
	display: inline-block;
}
.popover-styles {
	position: absolute;
    background-color: #fff;
    border: 3px solid #3598DC;
    top: 30px;
    z-index: 10;
    padding: 10px;
    text-align: center;
    font-size: 12px;
    font-style: italic;
    color: #525E64;
    box-shadow: 5px 5px 9px #aaa;
    width: 200px;
    left: 50%;
    margin-left: -100px;
}
.popover-styles.shift-left {
	margin-left: -150px;
}
.popover-styles:after, .popover-styles:before {
	bottom: 100%;
	left: 50%;
	border: solid transparent;
	content: " ";
	height: 0;
	width: 0;
	position: absolute;
	pointer-events: none;
}

.popover-styles:after {
	border-color: rgba(136, 183, 213, 0);
	border-bottom-color: #fff;
	border-width: 10px;
	margin-left: -10px;
}
.popover-styles.shift-left:after {
	margin-left: 40px;
}
.popover-styles:before {
	border-color: rgba(194, 225, 245, 0);
	border-bottom-color: #3598DC;
	border-width: 14px;
	margin-left: -14px;
}
.popover-styles.shift-left:before {
	margin-left: 36px;
}
</style>


// WEBPACK FOOTER //
// InfoPopover.vue?382fb463